/** constructor
  * @constructor
  * @param {string} name:   server (WMS or MapServer) layer name
  * @param {object} params: optional parameters
  * Provides mechanism for mapping multiple server layers
  * to one or more client layers.
 */
const Layer = function(name, params, defaultImgTyp) {
  this.name = name;         // server (WMS or MapServer) layer name
  this.state = false;       // true/false (display on/off)
  this.info = null;         // function to parse and render data for info tool
  this.imgType = defaultImgTyp; // imgType: gif, jpeg, png (only 1 img type per olLayer, could be a conflict)
  this.xgroup = false;      // only one member of the exclusive-group can be on at a time (non-transparent background layers)
  this.displayName = name;  // optional, for mobile legend
  this.olLyr = 'lyrBase';

  for (const key in params) {
    let value = params[key];
    switch (key) {
      case 'state':
        this.state = value;
        break;
      case 'info':
        this.info = value;
        break;
      case 'imgType':
        this.imgType = value;
        break;
      case 'displayName':
        this.displayName = value;
        break;
      case 'xgroup':
        this.xgroup = value;
        break;
      case 'olLyr':
        this.olLyr = value;
        break;
      default:
        console.error('Unknown Layer param:', key);
    } // switch
  }  // for
};  // Layer() constructor

/* update existing options, but can also add new ones */
Layer.prototype.setOptions = function(obj) {
  for (var opt in obj) {
    // console.log(this.name, opt, obj[opt]);
    this[opt] = obj[opt];
  }
}

export default Layer;
